import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const ModalContainer = styled.div`
    box-sizing: border-box;
    background: white;
    padding: clamp(20px, 4vw, 32px);
    border-radius: 12px;
    width: 100%;
    max-width: min(450px, calc(100vw - 32px));
    max-height: min(90vh, 90dvh);
    overflow-y: auto;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease-out;

    @keyframes slideIn {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const IconWrapper = styled.div`
    width: 64px;
    height: 64px;
    background: ${({ theme }) => (theme?.colors?.primary?.light || '#667eea')}20;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 24px;
    color: ${({ theme }) => theme?.colors?.primary?.main || '#667eea'};

    svg {
        width: 32px;
        height: 32px;
    }
`;

const Title = styled.h2`
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#1a202c'};
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 600;
`;

const Message = styled.p`
    color: ${({ theme }) => theme?.colors?.gray?.[600] || '#4a5568'};
    margin-bottom: 32px;
    line-height: 1.6;
    font-size: 15px;
`;

const Button = styled.button`
    background: ${({ theme }) => theme?.colors?.primary?.main || '#667eea'};
    color: white;
    border: none;
    padding: 14px 24px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s;
    width: 100%;

    &:hover {
        background: ${({ theme }) => theme?.colors?.primary?.dark || '#5568d3'};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const ShieldIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

export default function SessionExpiredModal({ onConfirm }) {
    return (
        <Overlay>
            <ModalContainer>
                <IconWrapper>
                    <ShieldIcon />
                </IconWrapper>
                <Title>Sessão Expirada por Segurança</Title>
                <Message>
                    Para garantir a segurança da sua conta, não foi possível renovar sua sessão automaticamente.
                    <br /><br />
                    Por favor, faça login novamente para continuar utilizando o sistema.
                </Message>
                <Button onClick={onConfirm}>
                    Entrar Novamente
                </Button>
            </ModalContainer>
        </Overlay>
    );
}
